/* Moved out of sections/gll-faith-prayer-footer.liquid (gllf-perf-v1) so browsers can cache it. Values that differ per page come from data-gllf-v on the script tag. */
(function(__V){var __J=function(i){return JSON.parse(__V[i])};

(() => {
const hub = document.getElementById('gll-faith-hub');
const btn = hub && hub.querySelector('[data-gfh-hide]');
if (!btn || btn.dataset.ready) return;
btn.dataset.ready = '1';
btn.addEventListener('click', () => {
  try { sessionStorage.setItem('gfh_hidden', '1'); } catch (_) {}
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const done = () => { document.documentElement.classList.add('gfh-off'); };
  if (reduce) return done();
  hub.style.overflow = 'hidden';
  hub.style.height = hub.offsetHeight + 'px';
  hub.style.transition = 'height .45s ease, opacity .3s ease, padding .45s ease';
  requestAnimationFrame(() => { hub.style.opacity = '0'; hub.style.height = '0px'; hub.style.paddingTop = '0px'; hub.style.paddingBottom = '0px'; });
  setTimeout(done, 480);
});
})();
(() => {
/* gllf-perf-v1: build the footer artwork only when a visitor scrolls near it */
const root = document.getElementById('gpfw');
if (!root || root.dataset.ready) return;
const gpfwStart = () => { if (root.dataset.ready) return; root.dataset.ready = '1'; gpfwInit(); };
if ('IntersectionObserver' in window) {
  const gpfwIO = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { gpfwIO.disconnect(); gpfwStart(); } }, { rootMargin: '1200px 0px' });
  gpfwIO.observe(document.getElementById('gll-faith-hub') || root);
} else gpfwStart();
function gpfwInit() {
const NS = 'http://www.w3.org/2000/svg';
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const el = (tag, attrs, parent) => { const n = document.createElementNS(NS, tag); if (attrs) for (const k in attrs) { const v = attrs[k]; if ((k === 'fill' || k === 'stroke') && String(v).indexOf('var(') === 0) n.style[k] = v; else n.setAttribute(k, v); } if (parent) parent.appendChild(n); return n; };
const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
const ease = (t) => t * t * (3 - 2 * t);
const hex = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const mix = (stops, t) => { t = clamp(t); const n = stops.length - 1; const i = Math.min(n - 1, Math.floor(t * n)); const f = t * n - i; const a = hex(stops[i]), b = hex(stops[i + 1]); return 'rgb(' + a.map((v, k) => Math.round(v + (b[k] - v) * f)).join(',') + ')'; };
const rng = (seed) => () => { seed |= 0; seed = seed + 0x6D2B79F5 | 0; let t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
const rad = (d) => d * Math.PI / 180;
const dir = (deg) => [Math.sin(rad(deg)), -Math.cos(rad(deg))];
const f1 = (n) => n.toFixed(1);

/* ---------- rotating verse (unchanged behaviour) ---------- */
const verses = __J(0).filter((v) => v[0] && v[1]);
if (!verses.length) verses.push(['1 Thessalonians 5:17', 'Pray without ceasing.']);
let last = -1; try { last = Number(sessionStorage.getItem('gpfwVerse')); } catch (_) {}
let choice; do { choice = Math.floor(Math.random() * verses.length); } while (verses.length > 1 && choice === last);
try { sessionStorage.setItem('gpfwVerse', String(choice)); } catch (_) {}
root.querySelector('#gpfw-verse').textContent = '“' + verses[choice][1] + '”';
const refEl = root.querySelector('#gpfw-reference');
refEl.textContent = verses[choice][0];
refEl.href = 'https://www.esv.org/' + encodeURIComponent(verses[choice][0]).replace(/%20/g, '+') + '/';

/* ---------- shared drawing: a true English lavender flower spike ----------
   Whorls (verticillasters) of florets with a gap between the lower whorls,
   tightening toward the tip; calyx + open corolla on lower/middle whorls, buds at the tip. */
const TIERS = [0, 7, 12.5, 17.3, 21.6, 25.4, 28.8, 31.8, 34.4];
function spike(parent, s, R, open) {
  const g = el('g', null, parent);
  el('path', { d: 'M0 0 V' + f1(-36 * s), stroke: 'var(--stem)', 'stroke-width': 0.9 * s, fill: 'none', 'stroke-linecap': 'round' }, g);
  const tiers = [];
  TIERS.forEach((ty, i) => {
    const tg = el('g', { transform: 'translate(0 ' + f1(-ty * s) + ')' }, g);
    const w = (1 - i / TIERS.length * 0.55) * s;
    const n = i < 7 ? 6 : 4;
    for (let k = 0; k < n; k++) {
      const x = (-3.3 + (6.6 * k) / (n - 1)) * w;
      const tilt = (x / (3.3 * w || 1)) * 38 + (R() - 0.5) * 12;
      const y = (k % 2 ? -1.1 : 0) * s + (R() - 0.5) * 0.8 * s;
      const fl = el('g', { transform: 'translate(' + f1(x) + ' ' + f1(y) + ') rotate(' + f1(tilt) + ')' }, tg);
      el('ellipse', { cx: 0, cy: 0, rx: f1(1.25 * w), ry: f1(2.1 * w), class: 'cx' }, fl);
      if (open && i < 7 && R() > 0.18) el('ellipse', { cx: 0, cy: f1(-1.9 * w), rx: f1(1.55 * w), ry: f1(1.25 * w), class: 'co co' + (i < 3 ? 0 : i < 5 ? 1 : 2) }, fl);
    }
    tiers.push(tg);
  });
  return { g, tiers };
}
function gravel(parent, cx, cy, wd, R, n) {
  const cols = ['#d8d0c4', '#c7bcae', '#e6e0d6', '#b3a898', '#cfc3b1'];
  el('ellipse', { cx, cy: cy + 5, rx: wd * 0.8, ry: 7, fill: '#e2d6c4', opacity: '.45', filter: 'url(#gfhSoft)' }, parent);
  for (let i = 0; i < n; i++) {
    const a = R() * Math.PI * 2, r = Math.sqrt(R());
    const x = cx + Math.cos(a) * wd * r, y = cy + 5 + Math.sin(a) * 8 * r;
    const rx = 1.2 + R() * 2.2;
    el('ellipse', { cx: f1(x), cy: f1(y), rx: f1(rx), ry: f1(rx * (0.55 + R() * 0.3)), fill: cols[(R() * cols.length) | 0], opacity: f1(1 - r * r * 0.85), transform: 'rotate(' + f1((R() - 0.5) * 40) + ' ' + f1(x) + ' ' + f1(y) + ')' }, parent);
  }
}
function foliage(parent, cx, cy, R, n, rw, rh) {
  const leaves = [];
  for (let i = 0; i < 7; i++) { const a = -60 + i * 20 + (R() - .5) * 10; const p = dir(a); el('path', { d: 'M' + f1(cx) + ' ' + cy + ' q' + f1(p[0] * 7) + ' ' + f1(p[1] * 5) + ' ' + f1(p[0] * 14) + ' ' + f1(p[1] * 9), stroke: '#8a6e4f', 'stroke-width': 2.4, fill: 'none', 'stroke-linecap': 'round' }, parent); }
  const list = [];
  for (let i = 0; i < n; i++) {
    const u = (R() * 2 - 1), v = Math.sqrt(R());
    const ox = cx + u * rw, oy = cy - 2 - v * rh * Math.sqrt(Math.max(0, 1 - u * u));
    list.push({ u, v, ox, oy, a: u * 72 + (R() - 0.5) * 34, len: 7 + R() * 9, w: 1.2 + R() * 0.7, c: v < 0.45 ? 'var(--leaf3)' : R() > 0.5 ? 'var(--leaf)' : 'var(--leaf2)' });
  }
  list.sort((a, b) => a.v - b.v);
  list.forEach((L) => {
    const g = el('g', { transform: 'translate(' + f1(L.ox) + ' ' + f1(L.oy) + ') rotate(' + f1(L.a) + ')' }, parent);
    el('path', { d: 'M0 0 Q ' + f1(0.6 + R() * 0.8) + ' ' + f1(-L.len * 0.5) + ' ' + f1((R() - 0.5) * 1.6) + ' ' + f1(-L.len), stroke: L.c, 'stroke-width': f1(L.w), fill: 'none', 'stroke-linecap': 'round' }, g);
    leaves.push({ g, ox: L.ox, oy: L.oy, a: L.a });
  });
  return leaves;
}
/* Stem as a curve that bends more toward the tip (droop), returns points + tip angle */
function stemPath(x0, y0, len, a0, a1, segs) {
  let x = x0, y = y0, d = 'M' + f1(x) + ' ' + f1(y), ang = a0;
  const pts = [[x, y]];
  for (let j = 1; j <= segs; j++) { ang = a0 + (a1 - a0) * Math.pow(j / segs, 2); const v = dir(ang); x += v[0] * len / segs; y += v[1] * len / segs; pts.push([x, y]); }
  for (let j = 1; j < pts.length - 1; j++) { const m = [(pts[j][0] + pts[j + 1][0]) / 2, (pts[j][1] + pts[j + 1][1]) / 2]; d += ' Q' + f1(pts[j][0]) + ' ' + f1(pts[j][1]) + ' ' + f1(m[0]) + ' ' + f1(m[1]); }
  d += ' L' + f1(x) + ' ' + f1(y);
  return { d, x, y, ang };
}

/* =====================  LEFT: the flower fades  ===================== */
const fsvg = root.querySelector('[data-fade-svg]');
const fart = root.querySelector('.gfh-art--fade');
const caption = root.querySelector('[data-fade-caption]');
const R1 = rng(7);
const BX = 100, BY = 186;
const fdefs = el('defs', null, fsvg);
const softF = el('filter', { id: 'gfhSoft', x: '-30%', y: '-100%', width: '160%', height: '300%' }, fdefs); el('feGaussianBlur', { stdDeviation: '3' }, softF);
const sunG = el('radialGradient', { id: 'gfhSun' }, fdefs);
el('stop', { offset: '0', 'stop-color': '#fff4d9', 'stop-opacity': '1' }, sunG); el('stop', { offset: '.5', 'stop-color': '#ffe1b3', 'stop-opacity': '.45' }, sunG); el('stop', { offset: '1', 'stop-color': '#ffe1b3', 'stop-opacity': '0' }, sunG);
const sun = el('circle', { cx: 100, cy: 60, r: 70, fill: 'url(#gfhSun)' }, fsvg);
const gndF = el('radialGradient', { id: 'gfhGndF' }, fdefs);
el('stop', { offset: '0', 'stop-color': '#e6dccd', 'stop-opacity': '.95' }, gndF); el('stop', { offset: '.6', 'stop-color': '#eee6da', 'stop-opacity': '.55' }, gndF); el('stop', { offset: '1', 'stop-color': '#f4efe8', 'stop-opacity': '0' }, gndF);
el('ellipse', { cx: 100, cy: 192, rx: 88, ry: 17, fill: 'url(#gfhGndF)' }, fsvg);
gravel(fsvg, BX, BY, 84, R1, 70);
const fLeaves = foliage(fsvg, BX, BY - 4, R1, 190, 44, 36);
const stemsG = el('g', null, fsvg);
const fStems = [];
const NST = 17;
for (let i = 0; i < NST; i++) {
  const a = -40 + (80 * i) / (NST - 1) + (R1() - 0.5) * 7;
  const len = 92 - Math.abs(a) * 0.45 + (R1() - 0.5) * 16;
  const g = el('g', null, stemsG);
  const path = el('path', { stroke: 'var(--stem)', 'stroke-width': 1.1, fill: 'none', 'stroke-linecap': 'round' }, g);
  const sp = spike(g, 0.9 + R1() * 0.15, R1, true);
  fStems.push({ a, len, path, sp, x0: BX + a * 0.55 + (R1() - 0.5) * 4, y0: BY - 16 - (1 - Math.abs(a) / 42) * 16, phase: R1() * 6.28, k: 0.6 + R1() * 0.8 });
}
const fallG = el('g', null, fsvg);
const fallers = [];
for (let i = 0; i < 40; i++) {
  const g = el('g', { opacity: 0 }, fallG);
  el('ellipse', { cx: 0, cy: 0, rx: 1.3, ry: 2, class: 'cx' }, g);
  el('ellipse', { cx: 0, cy: -1.8, rx: 1.4, ry: 1.1, class: 'co co1' }, g);
  fallers.push({ g, s: (R1() * NST) | 0, tier: 0.2 + R1() * 0.75, th: 0.34 + R1() * 0.5, drift: (R1() - 0.5) * 34, land: BY + (R1() - 0.3) * 10, spin: 180 + R1() * 360, o: null });
}
/* new growth: the Word stands — regrows more fully as the Prayer Field grows */
const growG = el('g', { opacity: 0 }, fsvg);
[['--stem', '#6f8f5a'], ['--leaf', '#89a17f'], ['--leaf2', '#afc3a4'], ['--leaf3', '#6d8566'], ['--cx', '#5b3f88'], ['--co0', '#8b62c9'], ['--co1', '#9670d2'], ['--co2', '#a585dc']].forEach(([k, v]) => growG.style.setProperty(k, v));
const R3 = rng(31);
const gLeaves = [];
for (let i = 0; i < 14; i++) { const k = i / 13; const a = (k - 0.5) * 150 + (R3() - 0.5) * 14; const ln = 10 + R3() * 7; const g = el('g', null, growG); el('path', { d: 'M0 0 Q 1.4 ' + f1(-ln * 0.5) + ' 0 ' + f1(-ln), stroke: i % 3 ? 'var(--leaf)' : 'var(--leaf2)', 'stroke-width': 2, fill: 'none', 'stroke-linecap': 'round' }, g); gLeaves.push({ g, a, x: BX + (k - 0.5) * 26, d: Math.abs(k - 0.5) }); }
const NG = 13;
const gStems = [];
for (let i = 0; i < NG; i++) {
  const slot = i === 0 ? 0 : (i % 2 ? 1 : -1) * Math.ceil(i / 2);
  const a = slot * 7 + (R3() - 0.5) * 5;
  const len = 74 - Math.abs(slot) * 3 + (R3() - 0.5) * 10;
  const g = el('g', { opacity: 0 }, growG);
  const path = el('path', { stroke: 'var(--stem)', 'stroke-width': 1.1, fill: 'none', 'stroke-linecap': 'round' }, g);
  const sp = spike(g, 0.72 + R3() * 0.16, R3, true);
  gStems.push({ a, len, g, path, sp, x0: BX + slot * 1.6, phase: R3() * 6.28 });
}
let growLevel = 0;
function drawGrow(rg, time) {
  growG.setAttribute('opacity', rg > 0 ? '1' : '0');
  if (rg <= 0) return;
  const count = 3 + growLevel * (NG - 3);
  const wind = reduce ? 0 : 1.6;
  gLeaves.forEach((L) => { const s = clamp(rg * 1.4 - L.d); L.g.setAttribute('transform', 'translate(' + f1(L.x) + ' ' + (BY - 6) + ') rotate(' + f1(L.a) + ') scale(' + f1(s) + ')'); });
  gStems.forEach((s, i) => {
    const vis = clamp(count - i);
    s.g.setAttribute('opacity', f1(vis));
    if (vis <= 0) return;
    const bloom = clamp(growLevel * NG * 1.1 - i + (i === 0 ? 0.45 : 0));
    const grow = ease(clamp(rg * 1.25 - i * 0.02)) * vis;
    const sway = Math.sin(time * 1.25 + s.phase) * wind;
    const st = stemPath(s.x0, BY - 10, s.len * grow * (0.45 + 0.55 * bloom), s.a * 0.5, s.a + sway, 6);
    s.path.setAttribute('d', st.d);
    s.sp.g.setAttribute('transform', 'translate(' + f1(st.x) + ' ' + f1(st.y) + ') rotate(' + f1(st.ang) + ') scale(' + f1(bloom * grow) + ')');
  });
}
/* a visiting honey bee */
const bee = el('g', { opacity: 0 }, fsvg);
const beeInner = el('g', null, bee);
const wingA = el('ellipse', { cx: -1, cy: -3.2, rx: 3.4, ry: 2, fill: '#ffffff', opacity: '.8', stroke: '#b9c3d6', 'stroke-width': '.3' }, beeInner);
const wingB = el('ellipse', { cx: 1.6, cy: -3, rx: 2.8, ry: 1.7, fill: '#ffffff', opacity: '.7', stroke: '#b9c3d6', 'stroke-width': '.3' }, beeInner);
el('ellipse', { cx: 0, cy: 0, rx: 4.2, ry: 2.6, fill: '#e3a92b' }, beeInner);
el('path', { d: 'M-1.4 -2.4 v4.8 M1 -2.5 v5 M3 -2 v4', stroke: '#3b2b16', 'stroke-width': 1 }, beeInner);
el('circle', { cx: -4.6, cy: 0, r: 1.8, fill: '#3b2b16' }, beeInner);
el('path', { d: 'M4.2 0 l1.6 .3', stroke: '#3b2b16', 'stroke-width': .7 }, beeInner);

const STAGES = [[0, caption.dataset.c0 || 'In full bloom'], [0.25, caption.dataset.c1 || 'The grass withers…'], [0.45, caption.dataset.c2 || '…the flower fades…']];
const wordEl = root.querySelector('[data-fade-word]');
const WORD_AT = 0.68;
let lastCap = '';
function drawFade(p, time) {
  const q = ease(p);
  fsvg.style.setProperty('--co0', mix(['#8b62c9', '#9d86bb', '#b4a086', '#9c8569', '#7c6852'], clamp(p * 1.18)));
  fsvg.style.setProperty('--co1', mix(['#9670d2', '#a58fc2', '#b8a68c', '#a08a6d', '#7f6b54'], p));
  fsvg.style.setProperty('--co2', mix(['#a585dc', '#ae9ac6', '#bcaa90', '#a38d70', '#826d56'], clamp(p * 0.92)));
  fsvg.style.setProperty('--cx', mix(['#5b3f88', '#6c5f7d', '#877760', '#77634d', '#655241'], p));
  fsvg.style.setProperty('--stem', mix(['#6f8f5a', '#899360', '#9b8a5d', '#86704f'], p));
  fsvg.style.setProperty('--leaf', mix(['#89a17f', '#98a182', '#a69a78', '#948166'], p));
  fsvg.style.setProperty('--leaf2', mix(['#afc3a4', '#b6bb9a', '#c1b392', '#a9967a'], p));
  fsvg.style.setProperty('--leaf3', mix(['#6d8566', '#7d8468', '#8a7f63', '#7a6a54'], p));
  sun.setAttribute('opacity', f1(0.55 - q * 0.45)); sun.setAttribute('cy', f1(60 + q * 40));
  const droop = Math.pow(q, 1.25);
  const windAmp = reduce ? 0 : (1 - q) * 2.2;
  fStems.forEach((s) => {
    const sway = Math.sin(time * 1.25 + s.phase) * windAmp * s.k + Math.sin(time * 2.9 + s.phase * 2) * windAmp * 0.25;
    const sign = s.a === 0 ? 1 : Math.sign(s.a);
    const a0 = s.a * (1 + droop * 0.35) + sway * 0.4;
    const a1 = s.a + sway + sign * droop * (70 + Math.abs(s.a) * 0.7);
    const st = stemPath(s.x0, s.y0, s.len * (1 - droop * 0.1), a0, a1, 8);
    s.path.setAttribute('d', st.d);
    s.tip = st;
    s.sp.g.setAttribute('transform', 'translate(' + f1(st.x) + ' ' + f1(st.y) + ') rotate(' + f1(st.ang + sign * droop * 12) + ') scale(' + f1(1 - q * 0.22) + ')');
    s.sp.tiers.forEach((tg, i) => { tg.setAttribute('opacity', f1(1 - clamp((p - 0.5 - i * 0.03) * 1.6) * 0.55)); });
  });
  fLeaves.forEach((L) => {
    const sag = L.a + Math.sign(L.a || 1) * droop * 34;
    L.g.setAttribute('transform', 'translate(' + f1(L.ox) + ' ' + f1(L.oy) + ') rotate(' + f1(sag) + ') scale(' + f1(1 - droop * 0.12) + ' ' + f1(1 - droop * 0.3) + ')');
  });
  fallers.forEach((fl, i) => {
    const f = clamp((p - fl.th) / 0.26);
    if (f <= 0) { fl.g.setAttribute('opacity', '0'); fl.o = null; return; }
    if (!fl.o) { const s = fStems[fl.s]; const d = dir(s.tip.ang); fl.o = [s.tip.x + d[0] * 36 * fl.tier * 0.8 * (1 - q * 0.2), s.tip.y + d[1] * 36 * fl.tier * 0.8 * (1 - q * 0.2)]; }
    const ff = Math.pow(f, 1.5);
    const x = fl.o[0] + fl.drift * f + Math.sin(f * Math.PI * 3 + i) * 4 * (1 - f);
    const y = fl.o[1] + (fl.land - fl.o[1]) * ff;
    fl.g.setAttribute('transform', 'translate(' + f1(x) + ' ' + f1(y) + ') rotate(' + f1(f * fl.spin) + ')');
    fl.g.setAttribute('opacity', '1');
  });
  const bv = clamp(1 - p * 3.4);
  bee.setAttribute('opacity', f1(bv));
  if (bv > 0 && !reduce) {
    const bx = 100 + Math.sin(time * 0.8) * 48 + Math.sin(time * 2.3) * 6, by = 52 + Math.sin(time * 1.6) * 16 + Math.cos(time * 3.1) * 3 - (1 - bv) * 60;
    const vx = Math.cos(time * 0.8) * 0.8 * 48 + Math.cos(time * 2.3) * 2.3 * 6;
    bee.setAttribute('transform', 'translate(' + f1(bx) + ' ' + f1(by) + ')');
    beeInner.setAttribute('transform', 'scale(' + (vx > 0 ? -1 : 1) + ' 1)');
    const flap = 0.35 + Math.abs(Math.sin(time * 38)) * 0.65;
    wingA.setAttribute('ry', f1(2 * flap)); wingB.setAttribute('ry', f1(1.7 * flap));
  }
  let label = STAGES[0][1]; STAGES.forEach(([t, s]) => { if (p >= t) label = s; });
  if (label !== lastCap) { caption.textContent = label; lastCap = label; }
  const on = p >= WORD_AT;
  caption.style.opacity = on ? '0' : '1';
  if (wordEl) wordEl.classList.toggle('is-on', on);
  const rg = ease(clamp((p - 0.64) / 0.24));
  sun.setAttribute('opacity', f1(0.55 - q * 0.45 + rg * 0.35));
  const dim = f1(1 - rg * (0.3 + growLevel * 0.45));
  stemsG.setAttribute('opacity', dim); fallG.setAttribute('opacity', dim);
  drawGrow(rg, time);
}

/* =====================  RIGHT: the Word stands  ===================== */
const word = document.getElementById('gll-word-'+__V[1]+'');
const trigger = word.querySelector('.gll-word__seed');
const csvg = word.querySelector('[data-cross-svg]');
const R2 = rng(19);
const CX = 100, CB = 190;
const cdefs = el('defs', null, csvg);
const glowG = el('radialGradient', { id: 'gfhGlow' }, cdefs);
el('stop', { offset: '0', 'stop-color': '#fff6de', 'stop-opacity': '1' }, glowG); el('stop', { offset: '.4', 'stop-color': '#ffdcaa', 'stop-opacity': '.55' }, glowG); el('stop', { offset: '1', 'stop-color': '#ffdcaa', 'stop-opacity': '0' }, glowG);
const woodV = el('linearGradient', { id: 'gfhWoodV', x1: 0, y1: 0, x2: 1, y2: 0 }, cdefs);
[['0', '#f1dcb6'], ['.45', '#dfbf8c'], ['1', '#c79e68']].forEach(([o, c]) => el('stop', { offset: o, 'stop-color': c }, woodV));
const woodH = el('linearGradient', { id: 'gfhWoodH', x1: 0, y1: 0, x2: 0, y2: 1 }, cdefs);
[['0', '#f3dfbb'], ['.5', '#e0c08e'], ['1', '#c89f6a']].forEach(([o, c]) => el('stop', { offset: o, 'stop-color': c }, woodH));
const blur = el('filter', { id: 'gfhBlur', x: '-50%', y: '-50%', width: '200%', height: '200%' }, cdefs); el('feGaussianBlur', { stdDeviation: '1.4' }, blur);
const clipV = el('clipPath', { id: 'gfhClipV' }, cdefs); const clipVr = el('rect', { x: 80, y: CB, width: 40, height: 0 }, clipV);
const clipH = el('clipPath', { id: 'gfhClipH' }, cdefs); const clipHr = el('rect', { x: CX, y: 66, width: 0, height: 30 }, clipH);

const glow = el('circle', { cx: CX, cy: 78, r: 96, fill: 'url(#gfhGlow)', opacity: 0 }, csvg);
const rays = el('g', { opacity: 0, filter: 'url(#gfhBlur)' }, csvg);
for (let i = 0; i < 20; i++) { const a = (i / 20) * Math.PI * 2 + 0.08; el('line', { x1: f1(CX + Math.cos(a) * 22), y1: f1(80 + Math.sin(a) * 22), x2: f1(CX + Math.cos(a) * (i % 2 ? 78 : 104)), y2: f1(80 + Math.sin(a) * (i % 2 ? 78 : 104)), stroke: '#ffe2b0', 'stroke-width': i % 2 ? 2 : 3.4, 'stroke-linecap': 'round', opacity: i % 2 ? '.5' : '.8' }, rays); }

const gndC = el('radialGradient', { id: 'gfhGndC' }, cdefs);
el('stop', { offset: '0', 'stop-color': '#e6dccd', 'stop-opacity': '.95' }, gndC); el('stop', { offset: '.6', 'stop-color': '#eee6da', 'stop-opacity': '.55' }, gndC); el('stop', { offset: '1', 'stop-color': '#f4efe8', 'stop-opacity': '0' }, gndC);
el('ellipse', { cx: CX, cy: CB + 5, rx: 80, ry: 15, fill: 'url(#gfhGndC)' }, csvg);
gravel(csvg, CX, CB - 2, 70, R2, 55);
const shadow = el('path', { d: 'M100 ' + (CB + 2) + ' L150 ' + (CB + 7) + ' L154 ' + (CB + 9) + ' L100 ' + (CB + 6) + 'Z', fill: '#8c7a66', opacity: 0, filter: 'url(#gfhBlur)' }, csvg);

/* back half of the vine (behind the wood) */
const backG = el('g', null, csvg);
/* the cross */
const crossV = el('g', { 'clip-path': 'url(#gfhClipV)' }, csvg);
el('rect', { x: CX - 7, y: 32, width: 14, height: CB - 32, fill: 'url(#gfhWoodV)', rx: 1.2 }, crossV);
el('path', { d: 'M' + (CX + 7) + ' 33 l3 2 V' + CB + ' h-3Z', fill: '#a97f4c' }, crossV);
el('path', { d: 'M' + (CX - 7) + ' 32 h14 l3 2 h-14Z', fill: '#f6e6c8' }, crossV);
for (let i = 0; i < 6; i++) { const x = CX - 5 + i * 2.1; let d = 'M' + f1(x) + ' 34'; for (let y = 40; y <= CB; y += 8) d += ' Q' + f1(x + (R2() - 0.5) * 1.6) + ' ' + (y - 4) + ' ' + f1(x + (R2() - 0.5) * 0.8) + ' ' + y; el('path', { d, stroke: '#a57b4b', 'stroke-width': .45, fill: 'none', opacity: '.45' }, crossV); }
el('ellipse', { cx: CX - 2, cy: 128, rx: 1.6, ry: 2.8, fill: '#b98d59', stroke: '#8f6a3f', 'stroke-width': .5, opacity: '.8' }, crossV);
el('ellipse', { cx: CX + 3, cy: 58, rx: 1.1, ry: 2.1, fill: '#b98d59', stroke: '#8f6a3f', 'stroke-width': .5, opacity: '.7' }, crossV);
const crossH = el('g', { 'clip-path': 'url(#gfhClipH)' }, csvg);
el('rect', { x: 56, y: 72, width: 88, height: 12, fill: 'url(#gfhWoodH)', rx: 1.2 }, crossH);
el('path', { d: 'M57 84 h88 l-1 3 h-86Z', fill: '#a97f4c' }, crossH);
for (let i = 0; i < 4; i++) { const y = 74 + i * 2.6; let d = 'M58 ' + f1(y); for (let x = 66; x <= 142; x += 8) d += ' Q' + (x - 4) + ' ' + f1(y + (R2() - 0.5) * 1.4) + ' ' + x + ' ' + f1(y + (R2() - 0.5) * 0.6); el('path', { d, stroke: '#a57b4b', 'stroke-width': .45, fill: 'none', opacity: '.45' }, crossH); }
/* front half of the vine, leaves and blooms */
const frontG = el('g', null, csvg);
const vineParts = [];
function helix(kind, n, turns) {
  const pts = [];
  for (let i = 0; i <= n; i++) {
    const s = i / n, ph = s * Math.PI * 2 * turns;
    if (kind === 'v') pts.push({ s, x: CX + Math.sin(ph) * 9.5, y: CB - 4 - s * 150, z: Math.cos(ph), ang: 0 });
    else pts.push({ s, x: CX + kind * (8 + s * 36), y: 78 + Math.sin(ph) * 8.5, z: Math.cos(ph), ang: kind * 90 });
  }
  let cur = null;
  pts.forEach((pt, i) => {
    const front = pt.z > 0;
    if (!cur || cur.front !== front) { if (cur) cur.pts.push(pt); cur = { front, pts: cur ? [cur.pts[cur.pts.length - 1], pt] : [pt] }; vineParts.push(Object.assign(cur, { kind })); }
    else cur.pts.push(pt);
  });
  return pts;
}
const hv = helix('v', 240, 4.3), hl = helix(-1, 90, 2.2), hr = helix(1, 90, 2.2);
vineParts.forEach((c) => {
  const d = 'M' + c.pts.map((q) => f1(q.x) + ' ' + f1(q.y)).join(' L');
  c.el = el('path', { d, pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': 1, stroke: c.front ? '#628c4c' : '#4f6a3b', 'stroke-width': c.front ? 2.1 : 1.6, fill: 'none', 'stroke-linecap': 'round', opacity: c.front ? 1 : 0.75 }, c.front ? frontG : backG);
  c.s0 = c.pts[0].s; c.s1 = c.pts[c.pts.length - 1].s;
});
const buds = [];
function sprout(pts, every, spikeEvery, kind) {
  pts.forEach((pt, i) => {
    if (i % every === every >> 1 && pt.z > -0.15) {
      const g = el('g', { transform: 'translate(' + f1(pt.x) + ' ' + f1(pt.y) + ') scale(0)' }, frontG);
      const lr = (i / every) % 2 ? 1 : -1;
      el('path', { d: 'M0 0 q' + (3 * lr) + ' -3 ' + (8 * lr) + ' -4 q-4 3 -8 4Z', fill: R2() > .5 ? 'var(--leaf)' : 'var(--leaf2)' }, g);
      el('path', { d: 'M0 0 q' + (-2.5 * lr) + ' 2 ' + (-7 * lr) + ' 1 q3 -2 7 -1Z', fill: 'var(--leaf)' }, g);
      if (R2() > 0.55) el('path', { d: 'M0 0 q' + (4 * lr) + ' 4 ' + (2 * lr) + ' 8 q-2 2 -3 0', stroke: '#7ea463', 'stroke-width': .6, fill: 'none', 'stroke-linecap': 'round' }, g);
      buds.push({ g, x: pt.x, y: pt.y, s: pt.s, kind, rot: 0, sc: 1 });
    }
    if (i % spikeEvery === (spikeEvery >> 1) + 2 && pt.z > 0.1) {
      const g = el('g', { transform: 'translate(' + f1(pt.x) + ' ' + f1(pt.y) + ') scale(0)' }, frontG);
      const rot = kind === 'v' ? (pt.x > CX ? 28 : -28) + (R2() - 0.5) * 16 : (R2() - 0.5) * 30;
      spike(el('g', { transform: 'rotate(' + f1(rot) + ')' }, g), 0.5, R2, true);
      buds.push({ g, x: pt.x, y: pt.y, s: pt.s + 0.04, kind, rot: 0, sc: 1, bloom: true, phase: R2() * 6.28 });
    }
  });
}
sprout(hv, 7, 15, 'v'); sprout(hl, 6, 14, 'l'); sprout(hr, 6, 14, 'r');
[-24, 0, 24].forEach((r) => { const g = el('g', { transform: 'translate(' + CX + ' 36) scale(0)' }, frontG); spike(el('g', { transform: 'rotate(' + r + ')' }, g), 0.5, R2, true); buds.push({ g, x: CX, y: 36, s: 1.02, kind: 'v', bloom: true, phase: R2() * 6.28 }); });
/* the plant that becomes the cross */
const plantG = el('g', null, csvg);
const pLeaves = foliage(plantG, CX, CB - 4, R2, 110, 30, 24);
const pStems = [];
for (let i = 0; i < 7; i++) {
  const a = -30 + i * 10 + (R2() - 0.5) * 5, len = 96 - Math.abs(a) * 0.5 + (R2() - 0.5) * 10;
  const g = el('g', null, plantG);
  const path = el('path', { stroke: 'var(--stem)', 'stroke-width': 1.2, fill: 'none', 'stroke-linecap': 'round' }, g);
  const sp = spike(g, 0.9, R2, true);
  pStems.push({ a, len, g, path, sp, x0: CX + a * 0.2, phase: R2() * 6.28 });
}
const motes = [];
for (let i = 0; i < 12; i++) motes.push({ n: el('circle', { r: f1(0.7 + R2() * 1.1), fill: '#fff7e0', opacity: 0 }, csvg), x: CX + (R2() - 0.5) * 90, sp: 6 + R2() * 10, ph: R2() * 10 });
csvg.style.setProperty('--stem', '#6f8f5a'); csvg.style.setProperty('--leaf', '#89a17f'); csvg.style.setProperty('--leaf2', '#afc3a4'); csvg.style.setProperty('--leaf3', '#6d8566');
csvg.style.setProperty('--cx', '#5b3f88'); csvg.style.setProperty('--co0', '#8b62c9'); csvg.style.setProperty('--co1', '#9670d2'); csvg.style.setProperty('--co2', '#a585dc');

function drawCross(t, time) {
  word.style.setProperty('--t', t.toFixed(3));
  const gather = ease(clamp(t / 0.42));
  const wind = reduce ? 0 : (1 - gather) * 1.8;
  pStems.forEach((s) => {
    const sway = Math.sin(time * 1.2 + s.phase) * wind;
    const a = s.a * (1 - gather) + sway;
    const st = stemPath(s.x0 + (CX - s.x0) * gather, CB - 6, s.len * (1 - gather * 0.25), a * 0.5, a, 6);
    s.path.setAttribute('d', st.d);
    s.sp.g.setAttribute('transform', 'translate(' + f1(st.x) + ' ' + f1(st.y) + ') rotate(' + f1(st.ang + gather * 25 * Math.sign(s.a || 1)) + ') scale(' + f1(1 - gather * 0.3) + ')');
    s.g.setAttribute('opacity', f1(1 - clamp((t - 0.3) / 0.28)));
  });
  pLeaves.forEach((L) => L.g.setAttribute('opacity', f1(1 - clamp((t - 0.45) / 0.3) * 0.45)));
  const v = ease(clamp((t - 0.28) / 0.3)), h = ease(clamp((t - 0.46) / 0.2));
  clipVr.setAttribute('y', f1(CB - (CB - 28) * v)); clipVr.setAttribute('height', f1((CB - 28) * v + 2));
  clipHr.setAttribute('x', f1(CX - 48 * h)); clipHr.setAttribute('width', f1(96 * h));
  shadow.setAttribute('opacity', f1(v * 0.5));
  const gv = clamp((t - 0.52) / 0.3), ga = clamp((t - 0.68) / 0.24);
  vineParts.forEach((c) => {
    const g = c.kind === 'v' ? gv : ga;
    const frac = clamp((g - c.s0) / Math.max(0.0001, c.s1 - c.s0));
    c.el.setAttribute('stroke-dashoffset', f1(1 - frac));
  });
  buds.forEach((b) => {
    const g = b.kind === 'v' ? gv : ga;
    const k = clamp((g - b.s) / 0.08);
    const pop = k * (1 + Math.sin(k * Math.PI) * 0.22);
    const sway = b.bloom && !reduce ? Math.sin(time * 1.4 + b.phase) * 3 * k : 0;
    b.g.setAttribute('transform', 'translate(' + f1(b.x) + ' ' + f1(b.y) + ') rotate(' + f1(sway) + ') scale(' + f1(pop) + ')');
  });
  glow.setAttribute('opacity', f1(0.2 + clamp((t - 0.55) / 0.4) * 0.8));
  const r = clamp((t - 0.78) / 0.22);
  rays.setAttribute('opacity', f1(r * (0.75 + (reduce ? 0 : Math.sin(time * 1.1) * 0.12))));
  rays.setAttribute('transform', 'rotate(' + f1(reduce ? 0 : time * 2) + ' ' + CX + ' 80)');
  motes.forEach((m) => {
    if (r <= 0 || reduce) { m.n.setAttribute('opacity', '0'); return; }
    const life = ((time * m.sp / 60 + m.ph) % 1);
    m.n.setAttribute('cx', f1(m.x + Math.sin(time + m.ph) * 4)); m.n.setAttribute('cy', f1(170 - life * 140));
    m.n.setAttribute('opacity', f1(r * Math.sin(life * Math.PI) * 0.9));
  });
}

/* =====================  scroll + animation loop  ===================== */
const band = document.getElementById('gll-faith-hub');
const vh = () => window.innerHeight || document.documentElement.clientHeight;
const atBottom = () => document.documentElement.scrollHeight - (window.scrollY + vh()) < 6;
function fadeTarget() { const r = fart.getBoundingClientRect(); const c = r.top + r.height / 2; let p = clamp((vh() * 0.95 - c) / (vh() * 0.95 - vh() * 0.3)); if (atBottom()) p = Math.max(p, clamp((vh() - r.top) / vh() * 1.4)); return p; }
function crossTarget() { const r = word.getBoundingClientRect(); const c = r.top + r.height / 2; let t = clamp((vh() * 0.98 - c) / (vh() * 0.98 - vh() * 0.42)); if (atBottom()) t = Math.max(t, clamp((vh() - r.top) / vh() * 1.6)); return t; }
let forced = false, p = 0, t = 0, pT = 0, tT = 0, visible = false, raf = 0;
const touch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
function frame(ms) {
  raf = 0;
  const time = ms / 1000;
  pT = fadeTarget(); tT = forced ? 1 : crossTarget();
  p += (pT - p) * 0.12; if (Math.abs(pT - p) < 0.002) p = pT;
  t += (tT - t) * 0.1; if (Math.abs(tT - t) < 0.002) t = tT;
  drawFade(p, time); drawCross(t, time);
  const idle = !reduce && (p < 0.999 || p >= WORD_AT || t > 0.78);
  if (visible && (idle || p !== pT || t !== tT)) raf = requestAnimationFrame(frame);
}
const kick = () => { if (!raf) raf = requestAnimationFrame(frame); };
if (reduce) { drawFade(1, 0); drawCross(1, 0); }
else {
  drawFade(0, 0); drawCross(0, 0);
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es[0].isIntersecting; if (visible) kick(); }, { rootMargin: '120px 0px' }).observe(band);
  else visible = true;
  addEventListener('scroll', () => { if (visible) kick(); }, { passive: true });
  addEventListener('resize', () => { if (visible) kick(); }, { passive: true });
  if (!touch) { trigger.addEventListener('mouseenter', () => { forced = true; kick(); }); trigger.addEventListener('mouseleave', () => { forced = false; kick(); }); }
  trigger.addEventListener('focus', () => { forced = true; kick(); });
  trigger.addEventListener('blur', () => { forced = false; kick(); });
  kick();
}

/* ---------- Prayer Field stats (unchanged API) ---------- */
const PRAYER_API_URL = __J(2);
const put = (id, value) => { const e = root.querySelector(id); if (e) e.textContent = Number(value || 0).toLocaleString(); };
const load = async () => {
  if (!PRAYER_API_URL || PRAYER_API_URL.includes('PASTE_') || PRAYER_API_URL.includes('script.google.com')) return;
  try {
    const url = PRAYER_API_URL + (PRAYER_API_URL.includes('?') ? '&' : '?') + 'action=stats';
    const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!response.ok || data.ok === false || !data.stats) return;
    put('#gpfw-seeds', data.stats.seedsPlanted); put('#gpfw-water', data.stats.plantsWatered); put('#gpfw-answered', data.stats.answeredPrayers);
    growLevel = clamp(Math.log10(1 + Number(data.stats.seedsPlanted || 0) + Number(data.stats.plantsWatered || 0)) / Math.log10(501));
    if (reduce) drawFade(1, 0); else kick();
  } catch (_) {}
};
load();
document.addEventListener('visibilitychange', () => { if (!document.hidden) load(); });


/* ================= Romans Road modal ================= */
const modal = word.querySelector('.gll-modal');
const panel = modal.querySelector('.grr__panel');
const stage = modal.querySelector('.grr__stage');
const steps = [...modal.querySelectorAll('.grr__step')];
const stops = [...modal.querySelectorAll('.grr__stop')];
const prev = modal.querySelector('[data-grr-prev]'), next = modal.querySelector('[data-grr-next]');
const count = modal.querySelector('[data-grr-count]');
const total = steps.length;
const startStop = modal.querySelector('[data-start]');
let current = startStop ? +startStop.dataset.go : 1;
let lastFocus = null;
const go = (n, focus) => {
  current = Math.max(1, Math.min(total, n));
  steps.forEach((s) => { s.hidden = +s.dataset.step !== current; });
  stops.forEach((b) => {
    const k = +b.dataset.go;
    b.classList.toggle('is-done', k < current);
    if (k === current) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
  });
  const fill = total > 1 ? ((current - 1) / (total - 1)) * 100 : 100;
  panel.style.setProperty('--grr-fill', fill + '%');
  count.textContent = current === total ? 'Your response' : 'Step ' + current + ' of ' + (total - 1);
  prev.disabled = current === 1;
  next.hidden = current === total;
  stage.scrollTop = 0;
  if (focus) { const h = steps[current - 1].querySelector('.grr__h'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
  const cur = stops[current - 1]; if (cur && cur.scrollIntoView && window.innerWidth <= 860) cur.scrollIntoView({ inline: 'center', block: 'nearest' });
};
stops.forEach((b) => b.addEventListener('click', () => go(+b.dataset.go, true)));
prev.addEventListener('click', () => go(current - 1, true));
next.addEventListener('click', () => go(current + 1, true));

const openModal = () => {
  lastFocus = document.activeElement;
  modal.classList.add('is-open'); word.classList.add('has-open-modal');
  modal.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('gll-modal-lock'); document.body.classList.add('gll-modal-lock');
  go(current, false);
  setTimeout(() => { const h = steps[current - 1].querySelector('.grr__h'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }, 30);
};
const closeModal = () => {
  modal.classList.remove('is-open'); word.classList.remove('has-open-modal');
  modal.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('gll-modal-lock'); document.body.classList.remove('gll-modal-lock');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
};
trigger.addEventListener('click', openModal);
modal.querySelector('.grr__close').addEventListener('click', closeModal);
modal.querySelector('.grr__backdrop').addEventListener('click', closeModal);

const prayerToggle = modal.querySelector('.gll-prayer__toggle');
const prayer = modal.querySelector('.gll-prayer');
prayerToggle.addEventListener('click', () => {
  const expanded = prayerToggle.getAttribute('aria-expanded') === 'true';
  prayerToggle.setAttribute('aria-expanded', String(!expanded));
  prayer.hidden = expanded;
  prayerToggle.textContent = expanded ? prayerToggle.dataset.showLabel : prayerToggle.dataset.hideLabel;
});
const share = modal.querySelector('[data-grr-share]');
share.addEventListener('click', async () => {
  const url = location.origin + '/pages/mission';
  const title = modal.querySelector('.grr__title').textContent.trim();
  try {
    if (navigator.share) { await navigator.share({ title, text: 'A seed of eternal hope from Great Lakes Lavender Farm', url }); return; }
    await navigator.clipboard.writeText(url); share.textContent = 'Link copied'; setTimeout(() => { share.textContent = 'Share this hope'; }, 2500);
  } catch (_) {}
});

modal.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') { closeModal(); return; }
  const tag = (event.target.tagName || '').toLowerCase();
  if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') && tag !== 'input' && tag !== 'textarea' && !event.target.closest('.grr__road')) {
    go(current + (event.key === 'ArrowRight' ? 1 : -1), true); event.preventDefault(); return;
  }
  if (event.key === 'Tab') {
    const focusable = [...modal.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), a[href], summary, [tabindex="0"]')].filter((n) => n.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0], lastEl = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); lastEl.focus(); }
    else if (!event.shiftKey && document.activeElement === lastEl) { event.preventDefault(); first.focus(); }
  }
});
}
})();

})(JSON.parse(document.currentScript.getAttribute('data-gllf-v')));
